import React from "react";

export default function GlassCard({ children, className, onClick, noHover }) {
  return (
    <div
      onClick={onClick}
      className={`
        relative overflow-hidden rounded-[2rem] 
        bg-white/60 backdrop-blur-xl 
        border border-white/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)]
        ${!noHover && "hover:shadow-2xl hover:-translate-y-1 hover:border-white/60 hover:bg-white/70 cursor-pointer"}
        transition-all duration-300 ease-out
        ${className}
      `}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-transparent pointer-events-none rounded-[2rem]"></div>
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
}
